import { breakpoints, min, max } from './breakpoints';
import colors from './colors';
import { ThemeProps } from './types';

const theme: ThemeProps = {
  colors,
  breakpoints,
  media: {
    min,
    max,
  },
};

export default theme;
